import { OfflineVideoFeed } from './OfflineVideoFeed';

export default OfflineVideoFeed;



// WEBPACK FOOTER //
// ./src/components/OfflineVideoFeed/index.js